// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5608) return "static/chunks/5608-5211b6db3357ebfb.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8577":"6a94becb3c78d99a","9349":"6336d4ae54786a9e"}[chunkId] + ".js";
};